var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "renewing-membership" }, [
        _c("div", { staticClass: "row" }, [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-md-6 text-md-right text-sm-left" },
            [
              _vm.members.length == 2
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "text" },
                      on: { click: _vm.openRequestIndividual },
                    },
                    [_vm._v("Request individual membership")]
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-md-12" },
            [
              _c("name-tiles", {
                attrs: { showInitial: "", items: _vm.members },
              }),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _vm.previousProducts.length > 0
        ? _c(
            "div",
            { staticClass: "previous-year-membership" },
            [
              _c("h6", [_vm._v("Previous Year Membership Renewal")]),
              _vm._v(" "),
              _c("product-selection", {
                attrs: {
                  display: "list",
                  hideTitle: "",
                  noBorder: "",
                  products: _vm.previousProducts,
                  type: "mandatory",
                },
                on: { "save-selection": _vm.updatePreviousProduct },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "renewing-membership membership-options" },
        [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-6 " }, [
              _c(
                "h6",
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.configOptions["renewal-lable-membership-options"]
                      ) +
                      "\n          "
                  ),
                  _c(
                    "el-link",
                    {
                      attrs: { type: "info", underline: false },
                      on: {
                        click: function ($event) {
                          _vm.membershipDialogVisible = true
                        },
                      },
                    },
                    [
                      _c("i", {
                        staticClass: "fas fa-info-circle",
                        attrs: { title: "" },
                      }),
                    ]
                  ),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-md-6 text-md-right text-sm-left" },
              [
                _vm.showConcession
                  ? _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            _vm.dialogVisible = true
                          },
                        },
                      },
                      [_vm._v("Apply for concessional membership")]
                    )
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-md-12 mb-1" },
              [
                _c("product-selection", {
                  attrs: {
                    display:
                      _vm.standardProducts.length === 1 ? "list" : "grid",
                    products: _vm.standardProducts,
                    type: "one",
                    selected: _vm.standardCurrentSelected,
                    hideDescription: "",
                  },
                  on: { "save-selection": _vm.updateStandardProduct },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("el-alert", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.membershipRequired,
                expression: "membershipRequired",
              },
            ],
            attrs: {
              title: "You have to choose one membership option",
              type: "error",
              "show-icon": "",
            },
            on: {
              close: function ($event) {
                _vm.membershipRequired = false
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.secondaryProducts.length > 0
        ? _c(
            "div",
            { staticClass: "previous-year-membership renew-membership" },
            [
              _c("h6", [_vm._v("Secondary Membership Renewal")]),
              _vm._v(" "),
              _c("product-selection", {
                attrs: {
                  display: "list",
                  hideTitle: "",
                  noBorder: "",
                  products: _vm.secondaryProducts,
                  type: "any",
                  selected: _vm.secondaryCurrentSelected,
                },
                on: { "save-selection": _vm.updateSecondaryProduct },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "renewal-btn d-flex justify-content-end justify-content-md-center",
        },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.nextStep } },
            [
              _vm._v("NEXT "),
              _c("i", { staticClass: "el-icon-arrow-right el-icon-right" }),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "dialog-popup",
          attrs: {
            title: _vm.configOptions["renewal-lable-membership-options"],
            visible: _vm.membershipDialogVisible,
          },
          on: {
            "update:visible": function ($event) {
              _vm.membershipDialogVisible = $event
            },
          },
        },
        [
          _c("p", {
            domProps: {
              innerHTML: _vm._s(
                _vm.configOptions["renewal-info-membership-options"]
              ),
            },
          }),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          attrs: { title: "Proof of Concession", visible: _vm.dialogVisible },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "dialog-concession" },
            [
              _c("p", [
                _vm._v(
                  "Retired superannuants, Pensioners and Students must provide proof to get concession rates."
                ),
              ]),
              _vm._v(" "),
              _vm._l(_vm.members, function (person) {
                return _c(
                  "div",
                  { key: person.id },
                  [
                    _c("h6", [_vm._v(_vm._s(person.fullName))]),
                    _vm._v(" "),
                    _c(
                      "el-upload",
                      {
                        ref: "upload" + person.id,
                        refInFor: true,
                        staticClass: "upload-demo",
                        attrs: {
                          drag: "",
                          action: "",
                          "auto-upload": false,
                          multiple: false,
                          accept: "image/jpeg,image/jpg,image/png",
                        },
                      },
                      [
                        _c("i", { staticClass: "el-icon-upload" }),
                        _vm._v(" "),
                        _c("div", { staticClass: "el-upload__text" }, [
                          _vm._v("Drop file here or "),
                          _c("em", [_vm._v("click to upload")]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "el-upload__tip",
                            attrs: { slot: "tip" },
                            slot: "tip",
                          },
                          [_vm._v("jpg/png files with a size less than 500kb")]
                        ),
                      ]
                    ),
                  ],
                  1
                )
              }),
              _vm._v(" "),
              _c(
                "el-checkbox",
                {
                  model: {
                    value: _vm.pocChecked,
                    callback: function ($$v) {
                      _vm.pocChecked = $$v
                    },
                    expression: "pocChecked",
                  },
                },
                [_vm._v("I confirm that I am eligible for concession pricing")]
              ),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("Cancel")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", disabled: !_vm.pocChecked },
                  on: { click: _vm.formSubmit },
                },
                [_vm._v("Confirm")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-6" }, [
      _c("h6", [_vm._v("You are renewing the membership for")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }